module.exports = "/virtual-football-league/img/amblems/left/logos/Roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Roma.png
// module id = 2122
// module chunks = 4